<template>
  <div
    class="footer-back-to-top-container"
    @click="footerToTop"
    :class="{ 'footer-back-to-top-container--hidden': !showToTop }"
  >
    <icon class="footer-back-top-top-icon" name="chevron-right" size="12px"></icon>
    <p class="footer-back-to-top-text body-sm">{{ text }}</p>
  </div>
</template>

<script>
import { scrollToTopBottom } from '@/scripts/helpers/scroll.js'

import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'FooterToTop',
  props: {
    text: {
      type: String,
      default: 'Back to Top'
    },
    dynamicallyHide: {
      type: Boolean,
      default: false
    },
    threshold: {
      type: Number,
      default: 150
    }
  },
  components: { Icon },
  methods: {
    footerToTop () {
      scrollToTopBottom('top')
    },
    toggleShowToTop () {
      const scrollPosition = document.body.scrollTop || document.documentElement.scrollTop;

      if (scrollPosition > this.threshold) {
        this.showToTop = true
      } else {
        this.showToTop = false
      }
    }
  },
  data () {
    return {
      showToTop: true
    }
  },
  mounted () {
    if (this.dynamicallyHide) {
      this.toggleShowToTop()
      window.addEventListener('scroll', this.toggleShowToTop)
      window.addEventListener('resize', this.toggleShowToTop)
    }
  }
}
</script>

<style scoped lang="scss">
.footer-back-to-top-container {
  position: fixed;
  bottom: 100px;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transform: translate(-50%, -50%);

  @media screen and (min-width: 700px) {
    bottom: 70px;
  }

  @include desktop-up {
    right: 70px;
    bottom: 100px;
    left: auto;
    transform: none;
  }

  @media screen and (max-width: 320px) {
    bottom: 132px;
  }

  .footer & {
    display: inline-flex;
    position: fixed;
    right: 0;
    bottom: 122px;
    left: auto;
    z-index: 100;
    min-height: 45px;
    min-width: 45px;
    padding: 0 12px;
    border: 0.5px solid $color-dark-grey;
    border-right: 0;
    background-color: rgba(255, 255, 255, 0.9);
    transform: none;
    opacity: 1;
    visibility: visible;
    transition: opacity 300ms ease-in-out, visibility 300ms ease-in-out;
  }
}

.footer-back-to-top-container--hidden {
  .footer & {
    opacity: 0;
    visibility: hidden;
  }
}

.footer-back-to-top-text {
  text-align: center;
  margin-top: 4px;
  font-size: rem(10);
  line-height: 12px;
  color: $color-black;
}

.footer-main-color-dark .footer-back-to-top-text {
  color: $color-black;
}

.footer-back-top-top-icon {
  transform: rotate(-90deg);
}

.footer-main-color-dark .footer-back-top-top-icon {
  fill: $color-black;
}
</style>
